var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56262 6.39572H17.3796C17.3796 3.29719 14.9009 0.777832 11.817 0.777832H0C0 3.87636 2.47868 6.39572 5.56262 6.39572Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4616V21.2224H0.0288219C3.37216 21.1934 6.0526 18.4714 6.0526 15.1122V13.4616H7.03254C10.1165 13.4616 12.624 10.9423 12.624 7.84375H5.59145C2.5075 7.87271 0 10.3631 0 13.4616Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon-white.c2b9691bfba60069a060f001d27e4f1d.svg";
export { ForwardRef as ReactComponent };